import React from 'react';
import { lineImage } from './retailUtils';

/** A bag line's photo (its colour's own photo when there is one — see lineImage). `sizes` also
 *  hands the browser the resized versions; `fallback` renders when the product has no photo. */
export default function LineImage({ line, sizes, fallback = null }) {
  const img = lineImage(line);
  if (!img) return fallback;
  return <img src={img.src} srcSet={sizes ? img.srcSet : undefined} sizes={sizes} alt="" />;
}
